<template>
    <section id="Gallery" class="Gallery white">
        <div class="row container">
            <div class="col s12 m12 l12 xl12 center-text description">
                <div class="title"><img src="/assets/images/gallery.png"></div>
            </div>
        </div>
        <div class="row container">

            <div class="col s12 filter">
                <span>Filter:</span> <dropdown :options="filters" :selected="selectedFilter" v-on:updateOption="updateFilter" :placeholder="'Filter Images'"></dropdown>
            </div>

            <div class="images">
                <div 
                    v-for="(image, index) in filteredImages"
                    :key="index"
                    class="col s12 m6 l4 gallery-images"
                >
                <img
                    v-lazy="image.src || image.thumb"
                >

                <!--@click="openGallery(index)"-->
                </div>
            </div>
            
            <LightBox 
                ref="lightbox"
                :media="filteredImages"
                :show-caption="false"
                :show-light-box="false"
                :showThumbs="false"
            ></LightBox>

        </div>
    </section>
</template>

<script>
    import ImagesService from '../../services/Images.js';
    import dropdown from 'vue-dropdowns';
    import LightBox from 'vue-image-lightbox'

    import _ from 'lodash';

    export default {
        name: 'Gallery',
        components: {
            LightBox,
            'dropdown': dropdown,
        },
        created: function() {
            const filterParam = this.$route.params.filter;
            var self = this;
            var tempFilterArray = [];
            ImagesService.getGallery().then(function(response) {
                var images = response.resources;
                for (var i = 0; i < images.length; i++) {
                    images[i].thumb = images[i].url;
                    images[i].src = images[i].url;
                    images[i].filter = images[i].tags.toString().toUpperCase();

                    for (var j = 0; j < images[i].tags.length; j++) {
                        tempFilterArray.push(images[i].tags[j]);
                    }
                }
                
                self.media = images;
                tempFilterArray = tempFilterArray.filter(function(item, i, ar){ return ar.indexOf(item) === i; });
                for (var k = 0; k < tempFilterArray.length; k++) {
                    self.filters.push({ name: tempFilterArray[k], search: tempFilterArray[k] });
                }

                if (filterParam) {
                    const filterIndex = _.findIndex(self.filters, function(o) { 
                        return o.search.replace(/\s/g,'').toLowerCase() == filterParam.toLowerCase(); 
                    });
                    self.selectedFilter = self.filters[filterIndex];
                    self.updateFilter(self.filters[filterIndex])
                }
                else {
                    self.selectedFilter = self.filters[0];
                }
            })
        
            //  https://<API_KEY>:<API_SECRET>@api.cloudinary.com/v1_1/<cloud_name>/resources/search
            //https://github.com/mikerodham/vue-dropdowns
            //https://164252723547836:2KpndCVeRYp6fazKKKOH3KRYxHM@api.cloudinary.com/v1_1/olentini/resources/image
            //https://cloudinary.com/documentation/search_api
            //https://support.cloudinary.com/hc/en-us/articles/202521082-How-to-list-all-images-within-a-folder-
            // var url = $.cloudinary.url('gallery', {format: 'json', type: 'list'});
        },
        data: function() {
            return {
                media: [],
                galleryFilter: 'All',
                selectedFilter: {},
                filters: [{
                    name: "All",
                    search: "All"
                }]
            }
        },
        methods: {
            // openGallery: function(index) {
            //     var index = index;
            //     //this.$refs.lightbox.showImage(index)
            // },
            updateFilter(filterName) {
                this.galleryFilter = filterName.search;
            }
        },
        computed: {
            filteredImages: function() {
                const self = this;
                if (this.galleryFilter === 'All') {
                    return this.media;
                } else {
                    return _.filter(this.media, function(o) { 
                        return o.filter.indexOf(self.galleryFilter.toUpperCase()) > -1; 
                    });
                }
            }
        }
    }
</script>

<style scoped>
    section {
        padding: 1.5rem 0rem 3.5rem 0rem;
    }
    .row { 
        margin-bottom: 0;
    }
    .title {
        font-weight: normal;
        font-size: 2.5rem;
        margin-bottom: 1rem;
        letter-spacing: .06rem;
        text-align: center;
    }

    .image {
        padding-right: 0;
        background: url(/assets/images/church2.jpg);
        background-size: cover;
        background-position: center;
        height: 770px;
        /* filter: grayscale(100%); */
    }

    .AboutUs .image img {
        width: 100%;
    }

    .church div {
        margin-bottom: 15px;
    } 

    .description {
        padding: 4rem 0rem 4rem 0rem;
        font-size: 1.25rem;
        line-height: 1.25;
    }

    .church {
        padding-bottom: 4rem;
    }
    .church img {
        width: 100%;
    }

    .call-to-action { 
        text-align: center;
        width: 100%;
    }

    .images div {
        overflow: hidden;
        /* margin-bottom: 15px */
    }
    .images img {
        /* width: 270px;
        height: 180px; */
        /* margin: 5px; */
        /* height: 180px; */
        width: 100%;
        border-radius: 3px;
        cursor: pointer;
        transition: all 0.4s ease;
        /* margin-bottom: 20px; */
        background-size: cover;
    }

    .thumbnailfade-leave-active,
    .thumbnailfade-enter-active {
        transition: all 0.4s ease;
    }

    .thumbnailfade-enter-active {
        transition-delay: 0.4s;
    }

    .thumbnailfade-enter,
    .thumbnailfade-leave-to {
        opacity: 0;
    }

    .filter {
        margin-bottom: 15px;
    }

    .filter a {
        /* padding: 0 20px; */
        font-size: 1rem;
        text-transform: uppercase;
        cursor: pointer;
    }

    .filter a.active {
        /* font-size: 1.25rem; */
        color: #222;
        font-weight: bold;
        /* border-bottom: 1px solid black; */
    }

    .gallery-images {
        /* max-height: 135px; */
        max-height: 290px;
        display: inline-block;
        margin-bottom: 15px;
    }

    .filter span {
        font-size: 1rem;
        line-height: 1;
        text-transform: uppercase;
    }

    button.vue-lb-arrow:focus {
        background: transparent;
    }
</style>